import React from "react";
import clsx from "clsx";
import ClearIcon from "@/assets/IconClearText.svg?url";
import SearchIcon from "@/assets/IconSearch.svg?url";

interface Props {
	value: string;
	handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
	handleClear: () => void;
	disabled: boolean;
}

const SearchInput = ({ value, handleChange, handleClear, disabled }: Props): JSX.Element => (
	<div className={clsx("searchInput", value.length && "searchInput--filled", disabled && "searchInput--disabled")}>
		<img className="searchInput_SearchIcon" src={SearchIcon} alt="" />
		<input placeholder="Search" value={value} onChange={handleChange} />
		<button className="searchInput_ClearButton" type="button" onClick={handleClear}>
			<img src={ClearIcon} alt="Clear search" />
		</button>
	</div>
);

export default SearchInput;
